<div class="chart-wrapper" #chartContainer>
  <ngx-charts-line-chart
    *ngIf="results.length > 0"
    (window:resize)="onResize($event)"
    [view]="view"
    [scheme]="colorScheme"
    [customColors]="customColors"
    [results]="results"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [legendPosition]="legendPosition"
    [legendTitle]="legendTitle"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [timeline]="timeline"
    [gradient]="gradient"
    [yScaleMin]="yScaleMin"
    [yScaleMax]="yScaleMax"
    (select)="onSelect($event)"
    #chart
  >
    <ng-template #tooltipTemplate let-model="model">
      <xhtml:div class="area-tooltip-container">
        <xhtml:div class="tooltip-item">
          <xhtml:div class="tooltip-item-head">
            <xhtml:span
              class="tooltip-item-color"
              [style.background-color]="
                model.series === '管理基準値' ? referenceLineColor : lineColor
              "
            ></xhtml:span>
            <span class="tooltip-label">{{
              model.series === "管理基準値" ? "管理基準値" : "変位"
            }}</span>
          </xhtml:div>
          <span class="tooltip-val">{{ formatValue(model.value) }}mm</span>
        </xhtml:div>
      </xhtml:div>
    </ng-template>
    <ng-template #seriesTooltipTemplate let-model="model">
      <xhtml:div class="area-tooltip-container">
        <xhtml:div class="tooltip-item">
          <xhtml:div class="tooltip-item-head">
            <xhtml:span
              class="tooltip-item-color"
              [style.background-color]="
                model.series === '管理基準値' ? referenceLineColor : lineColor
              "
            ></xhtml:span>
            <span class="tooltip-label">{{
              model.series === "管理基準値" ? "管理基準値" : "変位"
            }}</span>
          </xhtml:div>
          <span class="tooltip-val"
            >{{ formatValue(model[0].value) }}mm</span
          >
        </xhtml:div>
      </xhtml:div>
    </ng-template>
  </ngx-charts-line-chart>
</div>
